import { render } from "./ImportModal.vue?vue&type=template&id=6c9a5788&scoped=true"
import script from "./ImportModal.vue?vue&type=script&lang=ts"
export * from "./ImportModal.vue?vue&type=script&lang=ts"

import "./ImportModal.vue?vue&type=style&index=0&id=6c9a5788&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6c9a5788"

export default script